import { set } from "lodash";

export default function normalizeFiltros(filtros) {
    //Itera las propiedades del objeto filtros si es un String y es vacío lo convierte a null
    return Object.keys(filtros).reduce((acc, key) => {
        const value = filtros[key];
        set(acc, key, typeof value === 'string' && value === '' ? null : value);
        return acc;
    }, {});
}